exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt20[data-v-6e988cc4] {\n  margin-top: 20px;\n}\n.detail-summary[data-v-6e988cc4] {\n  margin-bottom: 16px;\n}\n.detail-section-title[data-v-6e988cc4] {\n  margin: 8px 0 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #303133;\n}\n", ""]);

// exports
